import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import JournalReplyForm from '../containers/JournalReplyFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class JournalReplyEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `JournalReplyEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('journal_reply_route_edit')} />
          <JournalReplyForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default JournalReplyEditScreen;

Logger.log('silly', `JournalReplyEditScreen loaded.`);
